import GameTypes from '../GameTypes/GameTypes'

const WithoutLogin = () => {
    return (
        <GameTypes new={false} url='/guest' />
    )
}

export default WithoutLogin